import replaceText from '../../helpers/replaceText';
import lang from './en_us.ts';

export interface Localisation {
  [key: string]: string;
}

export default (customLang?: Localisation) => {
  const translate = (key: keyof typeof customLang, replaceMap?: any) => {
    const str =
      customLang?.[key] !== undefined ? customLang?.[key] : lang?.[key] || key;
    if (replaceMap) {
      return replaceText(str, replaceMap);
    } else {
      return str;
    }
  };
  return { t: translate, translate };
};
